require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./porownanie-pakietow.json") })
        }
      }, "path---porownanie-pakietow");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---porownanie-pakietow!./.cache/json/porownanie-pakietow.json
// module id = 523
// module chunks = 231608221292675